import protoRoot from "../proto-root";
import CameraAlarmStatusBuilder from "../private/CameraAlarmStatus";

const name = "setCameraAlarmRPCRequest";

function create({ state }: { state: AlarmState }) {
  const SetCameraAlarmRPCRequest = protoRoot.lookupType("comm.SetCameraAlarmRPCRequest");
  const status = CameraAlarmStatusBuilder.create({ state });

  const payload = SetCameraAlarmRPCRequest.create({ status });

  return { payload, name };
}

const setCameraAlarmRpcRequest = { create, name };

export default setCameraAlarmRpcRequest;
